export default __webpack_public_path__ + "static/media/21.9dc85fd5.mp3";